// @ts-nocheck
import { secondary, normalText } from 'assets/colors/colors';

export function createMuiCommonTabTheme() {
  return {
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: '35px',
          '& .MuiTypography-root': {
            fontWeight: 500,
          },

          '& .MuiTabs-flexContainer ': {
            gap: 8,
          },

          '@media (max-width: 599.95px)': {
            '& .MuiTabs-scrollButtons': {
              display: 'flex',
            },
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: normalText.light,
          padding: '5px 8px',
          minHeight: '35px',

          '& .MuiBox-root': {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '15px',
            letterSpacing: '0.5px',
            textAlign: 'center',
            textTransform: 'uppercase !important',
          },

          '& .MuiBox-root .MuiChip-root': {
            color: normalText.light,
            maxHeight: 20,
          },

          '&.Mui-selected .MuiBox-root .MuiChip-root': {
            backgroundColor: secondary.main,
            color: normalText.main,
          },
        },
      },
    },
  };
}
